import { render, staticRenderFns } from "./frame.vue?vue&type=template&id=7e045007&scoped=true&"
import script from "./frame.vue?vue&type=script&lang=js&"
export * from "./frame.vue?vue&type=script&lang=js&"
import style0 from "./frame.vue?vue&type=style&index=0&lang=css&"
import style1 from "./frame.vue?vue&type=style&index=1&id=7e045007&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e045007",
  null
  
)

export default component.exports